import { jsx as _jsx } from "react/jsx-runtime";
import { NoOpLogger, } from '@dossierhq/core';
import { useMemo } from 'react';
import { PublishedDossierContext, } from '../../contexts/PublishedDossierContext.js';
import { usePublishedSchema } from '../../hooks/usePublishedSchema.js';
export function PublishedDossierProvider({ adapter, publishedClient, authKeys, logger, children, }) {
    const { schema, schemaError } = usePublishedSchema(publishedClient);
    const value = useMemo(() => {
        return {
            adapter,
            publishedClient,
            authKeys: authKeys ?? [{ authKey: '', displayName: 'Default' }],
            logger: logger ?? NoOpLogger,
            schema,
            schemaError,
        };
    }, [adapter, publishedClient, authKeys, logger, schema, schemaError]);
    return (_jsx(PublishedDossierContext.Provider, { value: value, children: children }));
}
//# sourceMappingURL=PublishedDossierProvider.js.map